import React, { useRef, useEffect } from 'react';
import { useInView } from 'framer-motion';
import MediaPlaceholder from './MediaPlaceholder';

export default function ResponsiveMedia({ 
  src, 
  alt, 
  label = "IMAGE",
  aspectRatio = "aspect-video",
  className = "" 
}) {
  const videoRef = useRef(null);
  const isInView = useInView(videoRef, { amount: 0.3 });

  useEffect(() => {
    if (videoRef.current) {
      if (isInView) {
        videoRef.current.play().catch(() => {});
      } else {
        videoRef.current.pause();
      }
    }
  }, [isInView]);

  if (!src) {
    return <MediaPlaceholder label={label} aspectRatio={aspectRatio} />;
  }

  const isVideo = src.match(/\.(mp4|webm|ogg)$/i);

  return (
    <div className={`relative w-full h-full overflow-hidden ${aspectRatio} ${className}`}>
      {isVideo ? (
        <video
          ref={videoRef}
          src={src}
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          aria-label={alt}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
}